export function getMedia() {
  const { innerWidth: width } = window;

  return {
    min320: width >= 320,
    min425: width >= 425,
    min475: width >= 475,
    min640: width >= 640,
    min740: width >= 740,
    min768: width >= 768,
    min992: width >= 992,
    min1024: width >= 1024,
    min1232: width >= 1232,
    min1376: width >= 1376,
  };
}

export function isTablet(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return getMedia().min640;
}
